
export default {
    root: {
        borderRadius: '{form.field.border.radius}',
        roundedBorderRadius: '2rem',
        gap: '0.5rem',
        paddingX: '.5rem',
        paddingY: '.3rem',
        iconOnlyWidth: '1.75rem',
        sm: {
            fontSize: '{form.field.sm.font.size}',
            paddingX: '{form.field.sm.padding.x}',
            paddingY: '{form.field.sm.padding.y}'
        },
        lg: {
            fontSize: '{form.field.lg.font.size}',
            paddingX: '{form.field.lg.padding.x}',
            paddingY: '{form.field.lg.padding.y}'
        },
        label: {
            fontWeight: '600'
        },
        raisedShadow: '0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)',
        focusRing: {
            width: '{form.field.focus.ring.width}',
            style: '{form.field.focus.ring.style}',
            offset: '{form.field.focus.ring.offset}'
        },
        badgeSize: '1rem',
        transitionDuration: '{form.field.transition.duration}'
    },
    colorScheme: {
        light: {
            root: {
                primary: {
                    background: '{primary.color}',
                    hoverBackground: '{primary.hover.color}',
                    activeBackground: '{primary.active.color}',
                    borderColor: '{primary.color}',
                    hoverBorderColor: '{primary.hover.color}',
                    activeBorderColor: '{primary.active.color}',
                    color: '{primary.contrast.color}',
                    hoverColor: '{primary.contrast.color}',
                    activeColor: '{primary.contrast.color}',
                    focusRing: {
                        color: 'transparent',
                        shadow: '0 0 0 0.2rem {primary.200}'
                    }
                },
                secondary: {
                    background: '{surface.200}',
                    hoverBackground: '{surface.300}',
                    activeBackground: '{surface.400}',
                    borderColor: '{surface.200}',
                    hoverBorderColor: '{surface.300}',
                    activeBorderColor: '{surface.400}',
                    color: '{surface.700}',
                    hoverColor: '{surface.800}',
                    activeColor: '{surface.800}',
                    focusRing: {
                        color: 'transparent',
                        shadow: '0 0 0 0.2rem {surface.200}'
                    }
                },
                info: {
                    background: '{info.500}',
                    hoverBackground: '{info.600}',
                    activeBackground: '{info.700}',
                    borderColor: '{info.500}',
                    hoverBorderColor: '{info.600}',
                    activeBorderColor: '{info.700}',
                    color: '#ffffff',
                    hoverColor: '#ffffff',
                    activeColor: '#ffffff',
                    focusRing: {
                        color: 'transparent',
                        shadow: '0 0 0 0.2rem {info.200}'
                    }
                },
                success: {
                    background: '{success.500}',
                    hoverBackground: '{success.600}',
                    activeBackground: '{success.700}',
                    borderColor: '{success.500}',
                    hoverBorderColor: '{success.600}',
                    activeBorderColor: '{success.700}',
                    color: '#ffffff',
                    hoverColor: '#ffffff',
                    activeColor: '#ffffff',
                    focusRing: {
                        color: 'transparent',
                        shadow: '0 0 0 0.2rem {success.200}'
                    }
                },
                warn: {
                    background: '{warn.500}',
                    hoverBackground: '{warn.600}',
                    activeBackground: '{warn.700}',
                    borderColor: '{warn.500}',
                    hoverBorderColor: '{warn.600}',
                    activeBorderColor: '{warn.700}',
                    color: '#ffffff',
                    hoverColor: '#ffffff',
                    activeColor: '#ffffff',
                    focusRing: {
                        color: 'transparent',
                        shadow: '0 0 0 0.2rem {warn.200}'
                    }
                },
                help: {
                    background: '{help.500}',
                    hoverBackground: '{help.600}',
                    activeBackground: '{help.700}',
                    borderColor: '{help.500}',
                    hoverBorderColor: '{help.600}',
                    activeBorderColor: '{help.700}',
                    color: '#ffffff',
                    hoverColor: '#ffffff',
                    activeColor: '#ffffff',
                    focusRing: {
                        color: 'transparent',
                        shadow: '0 0 0 0.2rem {help.200}'
                    }
                },
                danger: {
                    background: '{danger.500}',
                    hoverBackground: '{danger.600}',
                    activeBackground: '{danger.700}',
                    borderColor: '{danger.500}',
                    hoverBorderColor: '{danger.600}',
                    activeBorderColor: '{danger.700}',
                    color: '#ffffff',
                    hoverColor: '#ffffff',
                    activeColor: '#ffffff',
                    focusRing: {
                        color: 'transparent',
                        shadow: '0 0 0 0.2rem {danger.200}'
                    }
                },
                contrast: {
                    background: '{surface.950}',
                    hoverBackground: '{surface.900}',
                    activeBackground: '{surface.800}',
                    borderColor: '{surface.950}',
                    hoverBorderColor: '{surface.900}',
                    activeBorderColor: '{surface.800}',
                    color: '{surface.0}',
                    hoverColor: '{surface.0}',
                    activeColor: '{surface.0}',
                    focusRing: {
                        color: 'transparent',
                        shadow: '0 0 0 0.2rem {surface.400}'
                    }
                }
            },
            outlined: {
                primary: {
                    hoverBackground: '{primary.50}',
                    activeBackground: '{primary.100}',
                    borderColor: '{primary.200}',
                    color: '{primary.color}'
                },
                secondary: {
                    hoverBackground: '{surface.50}',
                    activeBackground: '{surface.100}',
                    borderColor: '{surface.200}',
                    color: '{surface.500}'
                },
                success: {
                    hoverBackground: '{success.50}',
                    activeBackground: '{success.100}',
                    borderColor: '{success.200}',
                    color: '{success.500}'
                },
                info: {
                    hoverBackground: '{info.50}',
                    activeBackground: '{info.100}',
                    borderColor: '{info.200}',
                    color: '{info.500}'
                },
                warn: {
                    hoverBackground: '{warn.50}',
                    activeBackground: '{warn.100}',
                    borderColor: '{warn.200}',
                    color: '{warn.500}'
                },
                help: {
                    hoverBackground: '{help.50}',
                    activeBackground: '{help.100}',
                    borderColor: '{help.200}',
                    color: '{help.500}'
                },
                danger: {
                    hoverBackground: '{danger.50}',
                    activeBackground: '{danger.100}',
                    borderColor: '{danger.200}',
                    color: '{danger.500}'
                },
                contrast: {
                    hoverBackground: '{surface.50}',
                    activeBackground: '{surface.100}',
                    borderColor: '{surface.700}',
                    color: '{surface.950}'
                },
                plain: {
                    hoverBackground: '{surface.50}',
                    activeBackground: '{surface.100}',
                    borderColor: '{surface.200}',
                    color: '{surface.700}'
                }
            },
            text: {
                primary: {
                    hoverBackground: '{primary.50}',
                    activeBackground: '{primary.100}',
                    color: '{primary.color}'
                },
                secondary: {
                    hoverBackground: '{surface.100}',
                    activeBackground: '{surface.200}',
                    color: '{surface.600}'
                },
                success: {
                    hoverBackground: '{success.50}',
                    activeBackground: '{success.100}',
                    color: '{success.500}'
                },
                info: {
                    hoverBackground: '{info.50}',
                    activeBackground: '{info.100}',
                    color: '{info.500}'
                },
                warn: {
                    hoverBackground: '{warn.50}',
                    activeBackground: '{warn.100}',
                    color: '{warn.500}'
                },
                help: {
                    hoverBackground: '{help.50}',
                    activeBackground: '{help.100}',
                    color: '{help.500}'
                },
                danger: {
                    hoverBackground: '{danger.50}',
                    activeBackground: '{danger.100}',
                    color: '{danger.500}'
                },
                contrast: {
                    hoverBackground: '{surface.50}',
                    activeBackground: '{surface.100}',
                    color: '{surface.950}'
                },
                plain: {
                    hoverBackground: '{surface.50}',
                    activeBackground: '{surface.100}',
                    color: '{surface.700}'
                }
            },
            link: {
                color: '{primary.color}',
                hoverColor: '{primary.color}',
                activeColor: '{primary.color}'
            }
        },
        dark: {
            root: {
                primary: {
                    background: '{primary.color}',
                    hoverBackground: '{primary.hover.color}',
                    activeBackground: '{primary.active.color}',
                    borderColor: '{primary.color}',
                    hoverBorderColor: '{primary.hover.color}',
                    activeBorderColor: '{primary.active.color}',
                    color: '{primary.contrast.color}',
                    hoverColor: '{primary.contrast.color}',
                    activeColor: '{primary.contrast.color}',
                    focusRing: {
                        color: 'transparent',
                        shadow: '0 0 0 0.2rem color-mix(in srgb, {primary.color}, transparent 80%)'
                    }
                },
                secondary: {
                    background: '{surface.800}',
                    hoverBackground: '{surface.700}',
                    activeBackground: '{surface.600}',
                    borderColor: '{surface.800}',
                    hoverBorderColor: '{surface.700}',
                    activeBorderColor: '{surface.600}',
                    color: '{surface.300}',
                    hoverColor: '{surface.200}',
                    activeColor: '{surface.100}',
                    focusRing: {
                        color: 'transparent',
                        shadow: '0 0 0 0.2rem color-mix(in srgb, {surface.300}, transparent 80%)'
                    }
                },
                info: {
                    background: '{info.400}',
                    hoverBackground: '{info.300}',
                    activeBackground: '{info.200}',
                    borderColor: '{info.400}',
                    hoverBorderColor: '{info.300}',
                    activeBorderColor: '{info.200}',
                    color: '{info.950}',
                    hoverColor: '{info.950}',
                    activeColor: '{info.950}',
                    focusRing: {
                        color: 'transparent',
                        shadow: '0 0 0 0.2rem color-mix(in srgb, {info.400}, transparent 80%)'
                    }
                },
                success: {
                    background: '{success.400}',
                    hoverBackground: '{success.300}',
                    activeBackground: '{success.200}',
                    borderColor: '{success.400}',
                    hoverBorderColor: '{success.300}',
                    activeBorderColor: '{success.200}',
                    color: '{success.950}',
                    hoverColor: '{success.950}',
                    activeColor: '{success.950}',
                    focusRing: {
                        color: 'transparent',
                        shadow: '0 0 0 0.2rem color-mix(in srgb, {success.400}, transparent 80%)'
                    }
                },
                warn: {
                    background: '{warn.400}',
                    hoverBackground: '{warn.300}',
                    activeBackground: '{warn.200}',
                    borderColor: '{warn.400}',
                    hoverBorderColor: '{warn.300}',
                    activeBorderColor: '{warn.200}',
                    color: '{warn.950}',
                    hoverColor: '{warn.950}',
                    activeColor: '{warn.950}',
                    focusRing: {
                        color: 'transparent',
                        shadow: '0 0 0 0.2rem color-mix(in srgb, {warn.400}, transparent 80%)'
                    }
                },
                help: {
                    background: '{help.400}',
                    hoverBackground: '{help.300}',
                    activeBackground: '{help.200}',
                    borderColor: '{help.400}',
                    hoverBorderColor: '{help.300}',
                    activeBorderColor: '{help.200}',
                    color: '{help.950}',
                    hoverColor: '{help.950}',
                    activeColor: '{help.950}',
                    focusRing: {
                        color: 'transparent',
                        shadow: '0 0 0 0.2rem color-mix(in srgb, {help.400}, transparent 80%)'
                    }
                },
                danger: {
                    background: '{danger.400}',
                    hoverBackground: '{danger.300}',
                    activeBackground: '{danger.200}',
                    borderColor: '{danger.400}',
                    hoverBorderColor: '{danger.300}',
                    activeBorderColor: '{danger.200}',
                    color: '{danger.950}',
                    hoverColor: '{danger.950}',
                    activeColor: '{danger.950}',
                    focusRing: {
                        color: 'transparent',
                        shadow: '0 0 0 0.2rem color-mix(in srgb, {danger.400}, transparent 80%)'
                    }
                },
                contrast: {
                    background: '{surface.0}',
                    hoverBackground: '{surface.100}',
                    activeBackground: '{surface.200}',
                    borderColor: '{surface.0}',
                    hoverBorderColor: '{surface.100}',
                    activeBorderColor: '{surface.200}',
                    color: '{surface.950}',
                    hoverColor: '{surface.950}',
                    activeColor: '{surface.950}',
                    focusRing: {
                        color: 'transparent',
                        shadow: '0 0 0 0.2rem color-mix(in srgb, {surface.0}, transparent 80%)'
                    }
                }
            },
            outlined: {
                primary: {
                    hoverBackground: 'color-mix(in srgb, {primary.color}, transparent 96%)',
                    activeBackground: 'color-mix(in srgb, {primary.color}, transparent 84%)',
                    borderColor: '{primary.700}',
                    color: '{primary.color}'
                },
                secondary: {
                    hoverBackground: 'rgba(255,255,255,0.04)',
                    activeBackground: 'rgba(255,255,255,0.16)',
                    borderColor: '{surface.700}',
                    color: '{surface.400}'
                },
                success: {
                    hoverBackground: 'color-mix(in srgb, {success.400}, transparent 96%)',
                    activeBackground: 'color-mix(in srgb, {success.400}, transparent 84%)',
                    borderColor: '{success.700}',
                    color: '{success.400}'
                },
                info: {
                    hoverBackground: 'color-mix(in srgb, {info.400}, transparent 96%)',
                    activeBackground: 'color-mix(in srgb, {info.400}, transparent 84%)',
                    borderColor: '{info.700}',
                    color: '{info.400}'
                },
                warn: {
                    hoverBackground: 'color-mix(in srgb, {warn.400}, transparent 96%)',
                    activeBackground: 'color-mix(in srgb, {warn.400}, transparent 84%)',
                    borderColor: '{warn.700}',
                    color: '{warn.400}'
                },
                help: {
                    hoverBackground: 'color-mix(in srgb, {help.400}, transparent 96%)',
                    activeBackground: 'color-mix(in srgb, {help.400}, transparent 84%)',
                    borderColor: '{help.700}',
                    color: '{help.400}'
                },
                danger: {
                    hoverBackground: 'color-mix(in srgb, {danger.400}, transparent 96%)',
                    activeBackground: 'color-mix(in srgb, {danger.400}, transparent 84%)',
                    borderColor: '{danger.700}',
                    color: '{danger.400}'
                },
                contrast: {
                    hoverBackground: '{surface.800}',
                    activeBackground: '{surface.700}',
                    borderColor: '{surface.500}',
                    color: '{surface.0}'
                },
                plain: {
                    hoverBackground: '{surface.800}',
                    activeBackground: '{surface.700}',
                    borderColor: '{surface.600}',
                    color: '{surface.0}'
                }
            },
            text: {
                primary: {
                    hoverBackground: 'color-mix(in srgb, {primary.color}, transparent 96%)',
                    activeBackground: 'color-mix(in srgb, {primary.color}, transparent 84%)',
                    color: '{primary.color}'
                },
                secondary: {
                    hoverBackground: '{surface.700}',
                    activeBackground: '{surface.600}',
                    color: '{surface.300}'
                },
                success: {
                    hoverBackground: 'color-mix(in srgb, {success.400}, transparent 96%)',
                    activeBackground: 'color-mix(in srgb, {success.400}, transparent 84%)',
                    color: '{success.400}'
                },
                info: {
                    hoverBackground: 'color-mix(in srgb, {info.400}, transparent 96%)',
                    activeBackground: 'color-mix(in srgb, {info.400}, transparent 84%)',
                    color: '{info.400}'
                },
                warn: {
                    hoverBackground: 'color-mix(in srgb, {warn.400}, transparent 96%)',
                    activeBackground: 'color-mix(in srgb, {warn.400}, transparent 84%)',
                    color: '{warn.400}'
                },
                help: {
                    hoverBackground: 'color-mix(in srgb, {help.400}, transparent 96%)',
                    activeBackground: 'color-mix(in srgb, {help.400}, transparent 84%)',
                    color: '{help.400}'
                },
                danger: {
                    hoverBackground: 'color-mix(in srgb, {danger.400}, transparent 96%)',
                    activeBackground: 'color-mix(in srgb, {danger.400}, transparent 84%)',
                    color: '{danger.400}'
                },
                contrast: {
                    hoverBackground: '{surface.800}',
                    activeBackground: '{surface.700}',
                    color: '{surface.0}'
                },
                plain: {
                    hoverBackground: '{surface.800}',
                    activeBackground: '{surface.700}',
                    color: '{surface.0}'
                }
            },
            link: {
                color: '{primary.color}',
                hoverColor: '{primary.color}',
                activeColor: '{primary.color}'
            }
        }
    }
};
